<template>
    <div class="distributor-login-index">
      <div class="login-form">
		<flex-line class="input-wrapper"  :show-border="true">
		    <input v-model="user_name" :placeholder="this.$t('placeholder.mobile')" type="text" />
		</flex-line>
		<flex-line class="input-wrapper"  :show-border="true">
		    <input v-model="password" :placeholder="this.$t('placeholder.password')" type="password" />
		</flex-line>
		<div class="common-btn ds-button-large mt-10" v-on:click="login">{{ $t('login.login') }}</div>
          <div class="link" @click="$router.push({name:'DistributorRegister'})">{{ $t('distributor.login.register') }}<i class="iconfont">&#xe60e;</i></div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'

import VueSocketIO from 'vue-socket.io'
import { login } from '../../../api/distributorLogin'
import { Indicator, Toast } from 'mint-ui'
import { mapMutations, mapState } from 'vuex'
import flexLine from '../../flexLine'

export default {
	components: {
		flexLine
	},
  name: 'DistributorLogin',
  data () {
    return {
      user_name: '',
      password: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.distributor.info
    })
  },
  created: function () {
    Indicator.close()
    if (this.user) {
      // this.$router.push({ name: 'DistributorHome' })
    }
  },
  methods: {
    ...mapMutations({
      distributorLogin: 'distributorLogin'
    }),
    login () {
      Indicator.open()
      login(this.user_name,
        this.password
      ).then(res => {
        Indicator.close()
        if(res.result.user.state == 0){
          Toast('该账号已被关闭')
          return
        }
        this.distributorLogin({ token: res.result.token, info: res.result.user })
        this.$router.push({ name: 'DistributorHome' })
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
  .distributor-login-index {
    background-image: url(../../../assets/image/distributor/login_back.png);
    background-size: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background-position: center;

    .login-form {
      position: absolute;
      top: 65%;
      opacity: .8;
      width: 90%;
      left: 5%;
      margin-top: -8rem;
        .link{font-size:.7rem;text-align: right;color:$primaryColor;margin-top:.3rem;}
      .logo {
        text-align: center;
        margin-bottom: 2rem;
        img {
          max-width: 100%;
          max-height: 3rem;
        }
      }
      .input-wrapper {
        padding: 0 $pageSpace;
      }
      .input {
        margin-bottom: 1px;
      }
      .btn {
        margin-top: 1.5rem;
      }
    }
  }
</style>
